import React, { useEffect, useState } from 'react';

import NextImage, { ImageProps as NextImageProps } from 'next/image';

import { FALLBACK_IMAGE_URL } from '@constants/constants';

export interface ImageProps extends NextImageProps {
  fallbackSrc?: string;
}

const Image = ({
  src = FALLBACK_IMAGE_URL,
  fallbackSrc = FALLBACK_IMAGE_URL,
  ...rest
}: ImageProps) => {
  const [imgSrc, setImgSrc] = useState(src);

  useEffect(() => {
    setImgSrc(src || fallbackSrc);
  }, [src]);

  // If Image component throws an error, set default
  const handleOnError = () => {
    setImgSrc(fallbackSrc);
  };

  return (
    <NextImage
      src={imgSrc}
      // if src does not exist this function will be triggered
      onError={handleOnError}
      {...rest}
    />
  );
};

export default Image;
